/**
 * Created by Andrey Popov on 10/15/25.
 */

const ExtraBarIconsDataSource = function () {
    cleverapps.EventEmitter.call(this);

    cleverapps.extraBar.onAddIcon = this.onAddIcon.bind(this);
    cleverapps.extraBar.onRemoveIcon = this.onRemoveIcon.bind(this);
};

ExtraBarIconsDataSource.prototype = Object.create(cleverapps.EventEmitter.prototype);
ExtraBarIconsDataSource.prototype.constructor = ExtraBarIconsDataSource;

ExtraBarIconsDataSource.prototype.createRow = function (iconModel) {
    return {
        id: iconModel.index,
        data: iconModel,
        weight: iconModel.extraBarWeight || -iconModel.index,
        ViewCtor: iconModel.customIcon
    };
};

ExtraBarIconsDataSource.prototype.getData = function () {
    return cleverapps.extraBar.listIcons().map(this.createRow.bind(this));
};

ExtraBarIconsDataSource.prototype.onAddIcon = function (model) {
    const newRow = this.createRow(model);
    this.trigger("add", newRow);
};

ExtraBarIconsDataSource.prototype.onRemoveIcon = function (model, silent) {
    this.trigger("remove", model.index, silent);
};

ExtraBarIconsDataSource.prototype.destructor = function () {
    cleverapps.extraBar.onAddIcon = function () {};
    cleverapps.extraBar.onRemoveIcon = function () {};
};